var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 6.99789H8.99805",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 14.0008V4.99705C4.99609 3.89202 5.8919 2.99622 6.99693 2.99622H17.0011C18.1061 2.99622 19.0019 3.89202 19.0019 4.99705V14.0008",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99609 19.0029V15.5015C2.99609 14.6727 3.66795 14.0009 4.49672 14.0009H6.3765C6.77421 14.0009 7.15563 14.1589 7.43694 14.44L8.41335 15.4164C8.78841 15.7911 9.29682 16.0016 9.82694 16.0017H14.1717C14.7027 16.0018 15.212 15.7909 15.5873 15.4154L16.4167 14.5861C16.7917 14.2115 17.3002 14.001 17.8303 14.0009H19.503C20.3317 14.0009 21.0036 14.6727 21.0036 15.5015V19.0029C21.0036 20.108 20.1078 21.0038 19.0028 21.0038H4.99693C3.8919 21.0038 2.99609 20.108 2.99609 19.0029Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesInboxIcon);
export default __webpack_public_path__ + "static/media/messages-inbox-icon.18767c1057a084042df4c568b3d84870.svg";
export { ForwardRef as ReactComponent };